import { Component, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
@Component({
  selector: 'app-expansion-panel-component',
  templateUrl: './expansion-panel.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./expansion-panel.component.scss'],
})


export class ExpansionPanelComponent {
  panelOpenState = false;

  currentLanguage = this.commonService.currentLanguage;

  constructor(public commonService: CommonService) { }

  scrollToTop(id: any) {
    let element = document.getElementById(id);
    if (element != null) {
      let topValue = element.offsetTop - 130;
      window.scrollTo({
        top: topValue,
        behavior: 'smooth',
      })
    }
  }

}

